// removed by extract-text-webpack-plugin
module.exports = {"form":"_1QvX1yxzYD vr vr_x4"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/forms/secure/PayNowForm/PayNowForm.module.less
// module id = 991
// module chunks = 3